import {getWords} from "../../..//components/network/recitewords";
import Vue from 'vue'
import {wordLogin} from "../../../components/network/recitewords";
export default {
    //查单个单词
    getWord(state,payload){
            // console.log(payload)
        state.searchWord=payload.word;
        state.currentCardItemWord=payload.word;
        state.words.word =payload.resDate.data.danci;
        state.words.cixing =payload.resDate.data.cixing;
        state.words.yinbiao = payload.resDate.data.yinbiao;
        state.words.fanyi = payload.resDate.data.fanyi;
        state.words.yinjie = payload.resDate.data.yinjie;
        state.words.ciyuan = payload.resDate.data.ciyuan;
    },
    //获取新词
    getNewWord(state,payload){
        // console.log(payload.data);
        state.newWordList=payload.data;
        state.currentCardItemWord=state.newWordList[0].word;
        this.commit('refreshInputList');

    },
    //获取新词
    getReviewWord(state,payload){
        // console.log(payload.data);
        // alert(payload.data.length)
        state.reviewWordLIst=payload.data;
        state.currentCardItemWord=state.reviewWordLIst[0].word;
        // this.commit('refreshInputList');

    },
    getRecoverWord(state,payload){
        state.recoverWordLIst=payload.data;
    },
    getPlanWord(state,payload){
        state.planWordLIst=payload.data;
    },
    getAllPlanWord(state,payload){
        // console.log(payload)
        state.allPlanWordLIst=payload.data;
    },
    //显示登录账号
    getUsername(state,payload){
        // console.log(payload);
        state.info.username=payload.account;
        state.info.autoplay=payload.aotoplay;
        state.info.newWordNum=payload.newswordnum;
        // state.info.ukus=payload.account;

    },
    //获取输入值
    getInputWord(state,payload){


            // alert(payload);
            // alert(state.newWordList[state.currentCardItemIndex].word);
            // if (state.wordListSwitch&&payload==state.newWordList[state.currentCardItemIndex].word){
            //     // alert(state.newWordList[state.currentCardItemIndex].id);
            //     state.backCardWordItemNum=state.currentCardItemIndex;
            //     state.newWordList.splice(state.currentCardItemIndex,1);
            //     state.isBackCardWordItem=true;
            // }else{
                Vue.set(state.inputWordList,state.currentCardItemIndex,payload);
            // }

    },
    //deleteWord
    changeNewList(state){
        // alert(state.currentCardItemIndex);
        state.backCardWordItemNum=state.currentCardItemIndex;
        state.newWordList.splice(state.currentCardItemIndex,1);
        if(state.newWordList.length-1 <= state.backCardWordItemNum){
            if(state.newWordList.length==0){
                state.newWordList=[{
                    word:'背完了',
                    yinjie:'恭喜',
                    yinbiao:'你',
                    fanyi:'请再接再厉！'
                }];
                state.backCardWordItemNum=0;
                state.currentCardItemIndex=0;
            }else{
                state.backCardWordItemNum=state.newWordList.length-1;
                state.currentCardItemIndex=state.newWordList.length-1;
                // alert(state.currentCardItemIndex)
            }

        }
        state.currentCardItemWord=state.newWordList[state.backCardWordItemNum].word;
        // state.isBackCardWordItem=true;
    },
    //用来控制打卡后更新新词list的index会置零的问题的状态值归零
    setIsBackCardWordItem(state){
        state.backCardWordItemNum=0;
        // state.isBackCardWordItem=false;
    },
    //当前item的index值，能靠它来定位单词操作，对newlist和inputlist起作用
    setCurrentCardItemIndex(state,payload){
        state.currentCardItemIndex=payload;
        // alert("444");
        // state.currentCardItemWord=state.newWordList[payload];
    },
    //当前单词，音频
    setCurrentCardItemWord(state,payload){
        state.currentCardItemWord=payload;
    },
    //输入值清空
    refreshInputList(state){
        state.inputWordList=[];
    },
    //控制显示的组件，例如，获取新词后自动加载显示其组件，以后加上控制隐藏某个组件，
    // splice这个方法可以减去数组中的某个值，push则是往加上一个值
    setShowModuleList(state,payload){

        if(!this.getters.isShow(payload)){
            state.showModuleList.push(payload);
        }
    },
    deleteShowModuleList(state,payload){
        for(let i=0; i <state.showModuleList.length;i++){
            if (payload==state.showModuleList[i]){
                state.showModuleList.splice(i,1);
            }
        }
    }

}